<template>
  <div class="app-layout__navbar" >
    <va-navbar>
      <template v-slot:left>
        <div class="left">
          <va-icon-menu-collapsed
            @click="isSidebarMinimized = !isSidebarMinimized"
            :class="{ 'x-flip': isSidebarMinimized }"
            class="va-navbar__item"
            :color="colors.primary"
          />
          <a href="#" @click="OpenHome()">
            <vuestic-logo />
          </a>
          <va-select
            style="width: 150px;"
            class="select-sp"
            v-model="sp"
            :label='$t("navbar.sp")'
            group-by="group"
            textBy="nam_sp"
            track-by="id_sp"
            :options="arr_sp"
            return-object
          />
        </div>
      </template>

      <template #right>
        <app-navbar-actions
          class="app-navbar__actions md5 lg4"
          :user-name="userName"
        />
      </template>
    </va-navbar>
  </div>
  <epicSpinnersVue/>
</template>
<script>
import { useColors } from "vuestic-ui";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { computed,watch,getCurrentInstance,defineComponent  } from "vue";
import VuesticLogo from "@/components/thcom-logo.vue";
import VaIconMenuCollapsed from "@/components/icons/VaIconMenuCollapsed";
import AppNavbarActions from "./components/AppNavbarActions";
export default defineComponent({
  components: {
    VuesticLogo,
    AppNavbarActions,
    VaIconMenuCollapsed
  },
  setup() {
    const { ctx: _this } = getCurrentInstance()
    const { getColors } = useColors();
    const { t } = useI18n();
    const colors = computed(() => getColors());
    const store = useStore();
    const firstmenu = store.state.mainMenu[0].name
    const isSidebarMinimized = computed({
      get: () => store.state.isSidebarMinimized,
      set: value => store.commit("updateSidebarCollapsedState", value)
    });
    const sp = computed({
      get: () => store.state.sp,
      set: value => store.commit("Select_sp", value)
    });
    const userName = computed(() => store.state.userInfo.username + ' [' + store.state.userInfo.nam_usergroup + ']');
    const chk_userName_reload = computed(() => store.state.userInfo.username);
    const arr_sp = computed(() => store.state.arr_sp);
    watch(arr_sp, () => {
        sp.value = arr_sp.value[0]
    });
    watch(sp, () => {
      if(typeof chk_userName_reload.value !== "undefined"){
        location.reload();
      }
    });
    const urlHome = process.env.VUE_APP_URL_MSP_FRONTEND_LOGIN
    const OpenHome = () => {
    window.location = urlHome;
    };
    return {
      t,
      firstmenu,
      chk_userName_reload,
      sp,
      arr_sp,
      colors,
      isSidebarMinimized,
      userName,
      OpenHome
    };
  }
});
</script>

<style lang="scss" scoped>
.va-navbar {
  box-shadow: var(--va-box-shadow);
  height: 60px;//แก้ในมือถือ navbar กว้างไป
  z-index: 2;
  &__center {
    @media screen and (max-width: 1200px) {
      .app-navbar__github-button {
        display: none;
      }
    }
    @media screen and (max-width: 950px) {
      .app-navbar__text {
        display: none;
      }
    }
  }

  @media screen and (max-width: 950px) {
    .left {
      width: 100%;
    }
    .app-navbar__actions {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
    .select-sp{
      position: absolute;
        left: 2.7rem;
        top: 1.25rem;
        height: fit-content;
        margin: auto;
    }
  }
}

.left {
  display: flex;
  align-items: center;
  & > * {
    margin-right: 1.0rem;
  }
  & > *:last-child {

    margin-right: 0;
  }
}

.x-flip {
  transform: scaleX(-100%);
}

.app-navbar__text > * {
  margin-right: 0.5rem;
  &:last-child {
    margin-right: 0;
  }
}
</style>
